<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ type }} {{ $t('Empresa') }}</h2>

			<div class="mb-4">
				<label class="block mb-2">{{ $t('Nombre') }}</label>
				<input
					type="text"
					v-model="campaignData.name"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.campaignData.name.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.campaignData.name.required"
					>
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2">{{ $t('Paises') }}</label>
				<select
					v-model="campaignData.countryId"
					ref="countries"
					id="countries"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option
						v-for="(country, index) in countries"
						:value="country.id"
						:key="index"
						:selected="country.id == campaignData.countryId"
					>
						{{ country.name }}
					</option>
				</select>
				<div v-if="$v.campaignData.countryId.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.campaignData.countryId.required"
					>
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>

			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { single } from '@/mixins'
import { queryCampaignByPk } from '@/apollo/queries/admin/campaigns'
import { fetchCountriesSelect } from '@/apollo/countries'
import {
	updateSingleCampaign,
	insertSingleCampaign
} from '@/apollo/mutations/admin/campaigns'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
	components: {
		PulseLoader
	},
	apollo: {
		campaignData() {
			const query = queryCampaignByPk(this.id)
			query.skip = this.id == null
			return query
		},
		countries() {
			return fetchCountriesSelect()
		}
	},
	data() {
		return {
			section: 'campaigns',
			campaignData: {
				name: '',
				countryId: null
			},
			countries: []
		}
	},
	mixins: [single],

	validations() {
		return {
			campaignData: {
				name: {
					required,
					maxLength: maxLength(50)
				},
				countryId: {
					required
				}
			}
		}
	},

	methods: {
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$apollo
					.mutate(
						this.id
							? updateSingleCampaign(this.id, this.campaignData)
							: insertSingleCampaign(this.campaignData)
					)
					.then(() => {
						this.stopLoadingState()
						this.id ? this.$alert("Tu Campaña está actualizada", "¡Enhorabuena!", "success") : this.$alert("Su Campaña ha sido creada", "¡Enhorabuena!", "success")
						})
					.catch(error => {
						this.setError(error)
						this.$alert( error , "Error", "error")
					})
			} else {
				this.$alert(this.$t('form_validation'), "Advertencia", "warning")
				this.setError(this.$t('form_validation'))
			}
		}
	}
}
</script>
